import { render, staticRenderFns } from "./modal-specifics.vue?vue&type=template&id=2f9bfb54&scoped=true&"
import script from "./modal-specifics.vue?vue&type=script&lang=js&"
export * from "./modal-specifics.vue?vue&type=script&lang=js&"
import style0 from "./modal-specifics.vue?vue&type=style&index=0&id=2f9bfb54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f9bfb54",
  null
  
)

export default component.exports